// src/components/RatingPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://backend-service:8080';


export default function RatingPage() {
  const { storeId } = useParams();
  const [average, setAverage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/v1/ratings/${storeId}`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch rating');
        return res.json();
      })
      .then((data) => {
        setAverage(data.average);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, [storeId]);

  const renderStars = (rating) => {
    const fullStars = Math.round(rating); // Round to nearest full star
    const maxStars = 5;
    return (
      <div style={{ fontSize: '24px', color: '#FFD700' }}>
        {[...Array(maxStars)].map((_, i) => (
          <span key={i}>{i < fullStars ? '★' : '☆'}</span>
        ))}
      </div>
    );
  };

  if (error) return <p>Error: {error}</p>;
  if (average === null) return <p>Loading...</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h2>Rating for Store #{storeId}</h2>
      <p>
        Average Rating: <strong>{average.toFixed(2)}</strong>
      </p>
      {renderStars(average)}
    </div>
  );
}
